"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonStepperStep = void 0;
const React = require("react");
const bronson_react_1 = require("@vwfs-bronson/bronson-react");
const stepper_step_enum_1 = require("./stepper.step.enum");
const BronsonStepperStep = (props) => {
    return (React.createElement(bronson_react_1.InstructionStepper.Step, Object.assign({}, (props.onClick ? { style: { cursor: 'pointer' } } : {}), (props.state ? { state: stepper_step_enum_1.BronsonStepperStepStatus.ACTIVE } : {}), props)));
};
exports.BronsonStepperStep = BronsonStepperStep;
